package com.bikompanion.ui.settings

/** A page of the settings window; [parent] is where its back button leads. */
enum class SettingsPage(
    val parent: SettingsPage?,
) {
    Main(parent = null),
    About(parent = Main),
    Licenses(parent = About),
}
